/*                                                                                                                     
,------.                                    ,--.          ,--.      ,--------.    ,------.            ,--.           
|  .-.  \,--. ,--.,--,--,  ,--,--.,--,--,--.`--' ,---.    |  | ,---.'--.  .--'    |  .-.  \  ,--,--.,-'  '-. ,--,--. 
|  |  \  :\  '  / |      \' ,-.  ||        |,--.| .--'    |  || .-. |  |  |       |  |  \  :' ,-.  |'-.  .-'' ,-.  | 
|  '--'  / \   '  |  ||  |\ '-'  ||  |  |  ||  |\ `--.    |  |' '-' '  |  |       |  '--'  /\ '-'  |  |  |  \ '-'  | 
`-------'.-'  /   `--''--' `--`--'`--`--`--'`--' `---'    `--' `---'   `--'       `-------'  `--`--'  `--'   `--`--'

Copyright (c) 2026 Dynamic IOT Data, Inc. All rights reserved.

@author Andrew Craig
*/
import { BaseService } from './base';

/** Road Segment Data Transfer Object
 *
 */
export interface RoadSegmentDTO {
    id: string;
    roadName: string;
    type: string;
    lanes: number;
    maxspeed: number;
    surface: string;
    geometry: {
        type: string;
        coordinates: number[][];
    };
}

/** Service to handle road segment data retrieval and processing
 *
 */
export class VisionRoadService extends BaseService {
    public async init() {
        return new Promise((resolve, _reject) => {
            console.log('Road Service Loaded');
            resolve('Loaded');
        });
    }

    /** Get information about the road segment at a given latitude and longitude
     * @returns Promise resolving to the road segment data
     * @param lat Latitude of the point to retrieve the road segment for
     * @param lng Longitude of the point to retrieve the road segment for
     * @returns
     */
    public getRoadSegment(lat: number, lng: number): Promise<RoadSegmentDTO> {
        const url = this.url + '/api/' + this.orgid + '/osm?lat=' + lat + '&lng=' + lng;
        fetch(url, {
            method: 'GET',
            headers: this.headers(),
        });
        return fetch(url, {
            method: 'GET',
            headers: this.headers(),
        }).then((response) => {
            return response.json() as Promise<RoadSegmentDTO>;
        });
    }

    public async getRoadSegmentFromId(roadSegmentId: string): Promise<RoadSegmentDTO> {
        const url = this.url + '/api/' + this.orgid + '/osm/' + roadSegmentId;
        const response = await this.get<RoadSegmentDTO>(url);
        if (response.parsedBody) {
            return response.parsedBody;
        } else {
            return Promise.reject('No road segment found for ID: ' + roadSegmentId);
        }
    }
}
